export default __webpack_public_path__ + "static/media/Tar.f23f0731.jpg";